import parseISO from "date-fns/parseISO";
import startOfMonth from "date-fns/startOfMonth";
import startOfYear from "date-fns/startOfYear";

const parseDate = (date: number | string | Date | null): Date | null => {
  if (!date) return null;
  if (!(date instanceof Date)) {
    // фикс кривой даты для safari "2019-12-06 00:00:00" -> "2019-12-06T00:00:00"
    if (typeof date === 'string') date = date.replace(' ', 'T');
    date = new Date(date);
  }
  if (isNaN(+date)) return null;
  return date;
}

export default parseDate;

// Парсинг без учета часового пояса
export const parseISODate = (date: number | string | Date | null): Date | null => {
  if (!date) return null;
  if (typeof date === 'string') return parseISO(date);
  if (typeof date === 'number') date = new Date(date);
  if (!(date instanceof Date) || isNaN(+date)) return null;
  return date;
}

export const parseMonth = (dateStr: string) => {
  const date = parseISODate(dateStr);
  return isValidDate(date) ? startOfMonth(date) : null;
}

export const parseYear = (dateStr: string) => {
  const date = parseISODate(dateStr);
  return isValidDate(date) ? startOfYear(date) : null;
}

export const isValidDate = (date: Date) => date instanceof Date && !isNaN(+date);